/* eslint-disable @typescript-eslint/no-misused-promises */

import { useCallback, useState } from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { UserPromptType } from '../constants';
import { usePrompt } from '../hooks/usePrompt';
import { useToggledByWorkingHours } from '../hooks/useToggledByWorkingHours';
import { Bold } from '../../shared/components/Bold';
import { getUserWorkingHoursURL } from '../../working-hours/utils/workingHoursUtils';
import { getParsedJsonPropertyValue } from '../../working-hours/records/CrmObject';
import { useUserPropertyValue } from '../../working-hours/hooks/useUserPropertyValue';
import { HS_STANDARD_TIME_ZONE, HS_WORKING_HOURS } from '../../working-hours/constants';
import { jsx as _jsx } from "react/jsx-runtime";
export const AgentStatusWorkingHoursPrompt = ({
  userId,
  isAway,
  children
}) => {
  const [wasDismissed, setWasDismissed] = useState(false);
  const {
    promptData,
    dismissPrompt,
    markPromptAsShown
  } = usePrompt(UserPromptType.AGENT_STATUS_WORKING_HOURS);
  const {
    value: userWorkingHours
  } = useUserPropertyValue(userId, HS_WORKING_HOURS, getParsedJsonPropertyValue);
  const {
    value: userTimezone
  } = useUserPropertyValue(userId, HS_STANDARD_TIME_ZONE);
  const {
    wasToggledByWorkingHours
  } = useToggledByWorkingHours({
    isAway,
    userWorkingHours,
    userTimezone
  });
  const isUnseen = promptData && promptData.viewedCount === 0;
  const shouldShowPrompt = isUnseen && wasToggledByWorkingHours && !wasDismissed;
  const handleOpenChange = useCallback(async e => {
    setWasDismissed(!e.target.value);
    await dismissPrompt();
  }, [setWasDismissed, dismissPrompt]);
  return /*#__PURE__*/_jsx(Popover, {
    paddingInline: "200",
    inlineSize: "330px",
    use: "longform",
    placement: "right",
    open: shouldShowPrompt,
    onOpenComplete: markPromptAsShown,
    onOpenChange: handleOpenChange,
    showCloseButton: true,
    content: {
      header: /*#__PURE__*/_jsx(Text, {
        as: "h5",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.prompts.agentStatusWorkingHoursHeader"
        })
      }),
      body: /*#__PURE__*/_jsx(View, {
        paddingBlockEnd: "400",
        as: "div",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "routing-ui.prompts.agentStatusWorkingHours_jsx",
          elements: {
            Link,
            Bold
          },
          options: {
            linkProps: {
              href: getUserWorkingHoursURL(userId),
              external: true
            }
          }
        })
      })
    },
    children: children
  });
};
AgentStatusWorkingHoursPrompt.displayName = 'AgentStatusWorkingHoursPrompt';